import { useState } from "react";
import { TextField, Button, Typography, Container, Box, Card, CardContent, Link } from "@mui/material";

export default function PasswordResetPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = () => {
    if (!email) {
      setMessage("Lütfen email adresinizi girin");
      return;
    }
    console.log("Sending password reset link to", email);
    setMessage("Şifre sıfırlama bağlantısı emailinize gönderildi");
    // API entegrasyonu burada yapılacak
  };

  return (
    <Container maxWidth="sm">
      <Box position="absolute" top={16} left={16}>
        <img src="/bilogo.png" alt="Logo" style={{ height: 100 }} />
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <Card sx={{ width: "100%", padding: 4, boxShadow: 3, position: "relative" }}>
          <CardContent>
            <Typography variant="h5" align="center" gutterBottom>
              Şifremi Unuttum
            </Typography>
            <Typography variant="body2" align="center" gutterBottom>
              Şifrenizi sıfırlamak için lütfen email adresinizi girin.
            </Typography>
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {message && (
              <Typography variant="body2" color="success.main" align="center" mt={1}>
                {message}
              </Typography>
            )}
            <Box mt={2}>
              <Button fullWidth variant="contained" color="primary" sx={{ fontWeight: "bold", height: 50 }} onClick={handleReset}>
                Şifre Sıfırla
              </Button>
            </Box>
            <Box mt={2} textAlign="center">
              <Typography variant="body2">Geri dön? <Link href="/login">Giriş Yap</Link></Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
}
